import React, { useMemo } from "react";
import {
  Document,
  Page,
  StyleSheet,
  Text,
  View,
  Image,
} from "@react-pdf/renderer";
import _ from "lodash";
import { insurers } from "constants/businessConstant";
import { theme } from "theme";
import { formatDateReverse } from "utlis/utils";

const ECardPdf = ({ members }) => {
  const styles = StyleSheet.create({
    section: {
      margin: "18pt auto",
    },
    eCardWrapper: {
      flexShrink: 0,
      overflow: "hidden",
      display: "flex",
      fontSize: 8,
      border: "1px solid black",
      borderLeft: "12px solid " + theme.primaryColor,
      width: 260,
      padding: 8,
      marginBottom: 8,
    },
    eCardDetailWrapper: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 8,
    },
    eCardHeader: {
      fontFamily: "Montserrat",
      marginBottom: 2,
    },
    eCardRow: {
      width: 90,
    },
  });

  const formatRelationship = (text) => {
    let title = text;
    switch (text) {
      case "FATHERINLAW":
        title = "Father-in-Law";
        break;
      case "MOTHERINLAW":
        title = "Mother-in-Law";
        break;
    }
    return title.toLowerCase();
  };

  function formatDate(date) {
    let new_date;
    new_date = date.split("-").join("/");
    return new_date;
  }

  const membersSegmentations = useMemo(() => {
    return _.chunk(members, 5);
  }, [members]);

  return (
    <Document>
      {membersSegmentations.map((membersChunk) => (
        <Page size="A4">
          <View style={styles.section}>
            {membersChunk.map((member, index) => (
              <View key={index.toString()} style={styles.eCardWrapper}>
                <View style={styles.eCardDetailWrapper}>
                  <View style={styles.eCardRow}>
                    <Text style={styles.eCardHeader}>Name</Text>
                    <Text>{member.name}</Text>
                  </View>
                  <View style={styles.eCardRow}>
                    <Text style={{ fontSize: "6pt" }}>Issued By</Text>
                    <Image
                      style={{
                        marginTop: "2pt",
                        width: "40pt",
                        maxHeight: "100%",
                      }}
                      
                      src={{uri: member.insurer,
                        method: "GET",
                        headers: { "Cache-Control": "no-cache" },
                        body: ""}}
                    />
                  </View>
                </View>
                <View style={styles.eCardDetailWrapper}>
                  <View style={styles.eCardRow}>
                    <Text style={styles.eCardHeader}>Policy Number</Text>
                    <Text>{member.policy_number}</Text>
                  </View>
                  <View style={styles.eCardRow}>
                    <Text style={styles.eCardHeader}>Unique Health ID</Text>
                    <Text>{member.client_id}</Text>
                  </View>
                </View>
                <View style={styles.eCardDetailWrapper}>
                  <View style={styles.eCardRow}>
                    <Text style={styles.eCardHeader}>Date of Birth</Text>
                    <Text>{formatDate(member.dob)}</Text>
                  </View>
                  <View style={styles.eCardRow}>
                    <Text style={styles.eCardHeader}>Relationship</Text>
                    <Text style={{ textTransform: "capitalize" }}>
                      {formatRelationship(member.relationship)}
                    </Text>
                  </View>
                </View>
                <View style={styles.eCardDetailWrapper}>
                  <View style={styles.eCardRow}>
                    <Text style={styles.eCardHeader}>Cover Start Date</Text>
                    <Text>
                      {member.policy_start_date
                        ? formatDateReverse(member.policy_start_date)
                        : "-"}
                    </Text>
                  </View>
                  <View style={styles.eCardRow}>
                    <Text style={styles.eCardHeader}>Cover End Date</Text>
                    <Text>
                      {member.policy_end_date
                        ? formatDateReverse(member.policy_end_date)
                        : "-"}
                    </Text>
                  </View>
                </View>
              </View>
            ))}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default ECardPdf;
